import React, { useEffect } from 'react';
    import { motion } from 'framer-motion';
    import Button from './Button';

    const SubscribeSection = () => {
      // Load SendFox script when component mounts
      useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://cdn.sendfox.com/js/form.js";
        script.charset = "utf-8";
        script.async = true;
        document.body.appendChild(script);

        return () => {
          // Cleanup script if needed, though usually safe to leave for form functionality
          const existingScript = document.querySelector('script[src="https://cdn.sendfox.com/js/form.js"]');
          if (existingScript) {
            existingScript.remove();
          }
        };
      }, []);

      return (
        <section className="py-20 lg:py-32 bg-sage-600">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-canela font-light text-white mb-6 leading-tight">
                Stay Connected on Your Journey
              </h2>
              <p className="text-lg text-sage-100 font-inter mb-12 leading-relaxed max-w-2xl mx-auto">
                Get weekly insights, tips, and encouragement delivered to your inbox. Join hundreds of women navigating divorce with confidence.
              </p>

              {/* SendFox Form */}
              <form 
                method="post" 
                action="https://sendfox.com/form/m7lxnd/36e6lo" 
                className="sendfox-form max-w-2xl mx-auto text-left bg-white/10 p-8 rounded-2xl backdrop-blur-sm border border-white/10" 
                id="36e6lo" 
                data-async="true" 
                data-recaptcha="true"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div className="space-y-2">
                    <label htmlFor="sendfox_form_name" className="block text-sm font-inter font-medium text-sage-50">
                      First Name
                    </label>
                    <input 
                      type="text" 
                      id="sendfox_form_name" 
                      placeholder="Your first name" 
                      name="first_name" 
                      required 
                      className="w-full px-6 py-3 rounded-xl border-0 focus:outline-none focus:ring-2 focus:ring-sage-300 font-inter text-gray-900 placeholder-gray-400 shadow-inner"
                    />
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="sendfox_form_email" className="block text-sm font-inter font-medium text-sage-50">
                      Email Address
                    </label>
                    <input 
                      type="email" 
                      id="sendfox_form_email" 
                      placeholder="Your email address" 
                      name="email" 
                      required 
                      className="w-full px-6 py-3 rounded-xl border-0 focus:outline-none focus:ring-2 focus:ring-sage-300 font-inter text-gray-900 placeholder-gray-400 shadow-inner"
                    />
                  </div>
                </div>

                <div className="flex items-start mb-8">
                  <div className="flex items-center h-5">
                    <input 
                      id="gdpr" 
                      name="gdpr" 
                      type="checkbox" 
                      value="1" 
                      required 
                      className="h-4 w-4 text-sage-800 border-white/20 rounded focus:ring-sage-400 bg-white/20"
                    />
                  </div>
                  <div className="ml-3 text-sm">
                    <label htmlFor="gdpr" className="font-inter text-sage-100 cursor-pointer">
                      I agree to receive email updates and occasional promotions.
                    </label>
                  </div>
                </div>

                {/* Honeypot for bot protection */}
                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                  <input type="text" name="a_password" tabIndex="-1" value="" autoComplete="off" />
                </div>

                <div className="text-center">
                  <Button 
                    type="submit" 
                    className="w-full md:w-auto px-12 py-4 bg-sage-800 text-white hover:bg-sage-900 focus:ring-white/50 shadow-xl hover:shadow-2xl border-sage-800 hover:border-sage-900 text-lg"
                  >
                    Subscribe Now
                  </Button>
                </div>
              </form>

              <p className="text-sage-200 font-inter text-xs mt-6 opacity-80">
                Respected privacy. Unsubscribe at any time.
              </p>
            </motion.div>
          </div>
        </section>
      );
    };

    export default SubscribeSection;